import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { DataTable, PageHeader, renderCell } from "@/components/shared";
import { api, notifyErr, downloadFile, fmtMoney } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KINDS = [["noleggi", "Noleggi"], ["prenotazioni", "Prenotazioni"], ["flotta", "Utilizzo flotta"], ["incassi", "Incassi"], ["cauzioni", "Cauzioni"], ["scadenze", "Scadenze"], ["manutenzioni", "Manutenzioni"]];
const TYPES = { planned_start: "datetime", planned_end: "datetime", start: "datetime", end: "datetime", date: "date", due_date: "date", amount: "money", price: "money",
  deposit: "money", cost: "money", revenue: "money", historical_total: "money", status: "status", type: "status" };

export default function Reports() {
  const { can } = useAuth();
  const [kind, setKind] = useState("noleggi");
  const [p, setP] = useState({ from: "", to: "", include_history: false });
  const [data, setData] = useState(null);
  useEffect(() => {
    setData(null);
    api.get(`/reports/${kind}`, { params: { ...p, include_history: p.include_history ? "true" : "" } }).then((r) => setData(r.data)).catch((e) => { notifyErr(e); setData({ rows: [], columns: [], summary: {} }); });
  }, [kind, p]);
  const qs = new URLSearchParams({ from: p.from, to: p.to, include_history: p.include_history ? "true" : "" }).toString();
  return (
    <div>
      <PageHeader title="Report" subtitle="Analisi di noleggi, flotta, incassi, cauzioni, scadenze e manutenzioni">
        {can("reports", "export") && <>
          <Button variant="outline" onClick={() => downloadFile(`/reports/${kind}?${qs}&format=csv`, `report_${kind}.csv`)} data-testid="report-export-csv"><Download size={16} className="mr-1" />CSV</Button>
          <Button variant="outline" onClick={() => downloadFile(`/reports/${kind}?${qs}&format=xlsx`, `report_${kind}.xlsx`)} data-testid="report-export-xlsx"><Download size={16} className="mr-1" />Excel</Button>
        </>}
      </PageHeader>
      <div className="flex flex-wrap gap-1 mb-4 bg-[#09090B] p-1 rounded-lg border border-zinc-800 w-fit">
        {KINDS.map(([k, l]) => <button key={k} onClick={() => setKind(k)} data-testid={`report-${k}`} className={`px-3 py-1.5 text-sm rounded-md ${kind === k ? "bg-brand text-white" : "text-zinc-400 hover:text-white"}`}>{l}</button>)}
      </div>
      <div className="flex flex-wrap gap-3 items-center mb-4">
        <Input type="date" value={p.from} onChange={(e) => setP({ ...p, from: e.target.value })} className="w-40 h-10" data-testid="report-from" />
        <Input type="date" value={p.to} onChange={(e) => setP({ ...p, to: e.target.value })} className="w-40 h-10" data-testid="report-to" />
        <label className="flex items-center gap-2 text-sm text-zinc-400"><Switch checked={p.include_history} onCheckedChange={(v) => setP({ ...p, include_history: v })} data-testid="report-include-history" />Includi storico importato</label>
      </div>
      {data && <div className="flex flex-wrap gap-3 mb-4" data-testid="report-summary">
        <div className="bg-card border border-zinc-800 rounded-lg px-4 py-3"><div className="text-[11px] uppercase text-zinc-500">Record</div><div className="text-xl font-display font-bold">{data.summary.count}</div></div>
        {Object.entries(data.summary).filter(([k]) => k !== "count").map(([k, v]) => (
          <div key={k} className="bg-card border border-zinc-800 rounded-lg px-4 py-3"><div className="text-[11px] uppercase text-zinc-500">Totale {k}</div><div className="text-xl font-display font-bold">{fmtMoney(v)}</div></div>))}
      </div>}
      <DataTable rows={data ? data.rows.map((r, i) => ({ ...r, id: r.id || `r${i}` })) : null} testid="report-table"
        columns={(data?.columns || []).map(([key, lbl]) => ({ key, label: lbl, render: (r) => renderCell({ key, type: TYPES[key] }, r) }))} />
    </div>
  );
}
